import store from "../store/store";
import AdminPermissionEnum from "../enums/AdminPermissionEnum";
import ProfileEnum from "../enums/ProfileEnum";

// Helpers de permissao de admin no front. Espelham a semantica do backend
// (src/shared/utils/permissions.ts): admin nivel 1 (SUPER_ADMIN) tem acesso
// total; os demais admins precisam da permissao concedida (opt-in, inclusive
// quem tem permissions null); nao-admin nao participa do modelo de permissoes.

function resolveUser(user) {
  if (user) {
    return user;
  }
  const state = store.getState();
  return state?.auth?.user;
}

export function isAdmin(user) {
  const currentUser = resolveUser(user);
  return currentUser?.profile === ProfileEnum.ADMIN.value;
}

export function isSuperAdmin(user) {
  const currentUser = resolveUser(user);

  if (!isAdmin(currentUser)) {
    return false;
  }

  return (
    Array.isArray(currentUser.permissions) &&
    currentUser.permissions.includes(AdminPermissionEnum.SUPER_ADMIN)
  );
}

export function hasPermission(permission, user) {
  const currentUser = resolveUser(user);

  if (!isAdmin(currentUser)) {
    return false;
  }

  if (isSuperAdmin(currentUser)) {
    return true;
  }

  return (
    Array.isArray(currentUser.permissions) &&
    currentUser.permissions.includes(permission)
  );
}
